:host {
  display: inline-block;
  width: auto;
  padding: 0 18px;
  border-radius: 0 10px 10px 10px;
  background-color: #ffffff;
  background-color: var(--bg-primary);

  img {
    width: 60px;
    height: 60px;
    vertical-align: bottom;
  }
}
